/* eslint-disable react-hooks/exhaustive-deps */
import { ArrowRightOutlined } from '@ant-design/icons';
import {
    Button,
    DatePicker,
    Divider,
    Form,
    Progress,
    Upload,
    notification,
} from 'antd';
import React, { useEffect, useState } from 'react';
import ImgCrop from 'antd-img-crop';
import { useTranslation } from 'react-i18next';
import term_read_only from './../../../../../assets/Images/svg/term_read_only.svg';
import term_checked from './../../../../../assets/Images/svg/term_check.svg';
import circleInfo from './../../../../../assets/Images/svg/circle-information.svg';
import GlobalService from '../../../../../services/Global.service';
import EditorPrivacy from '../../../../../components/Shared/forms/EditorPrivacy';
import Sticky from 'react-sticky-el';

export default function Step1(props) {
    const {
        currentProgress,
        form,
        setImage,
        selectDocLayout,
        setSelectDocLayout,
    } = props;
    const { t } = useTranslation();

    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        let checkDoc = null;
        if (typeof form.getFieldValue('showAcknowledgeButton') == 'boolean') {
            checkDoc = form.getFieldValue('showAcknowledgeButton') ? 2 : 1;
        }
        setSelectDocLayout(checkDoc);
    }, []);

    useEffect(() => {
        const getImage = async () => {
            if (form?.getFieldValue('logoId')) {
                try {
                    const { data } = await GlobalService.getImage(
                        form?.getFieldValue('logoId')
                    );
                    if (data.resultData?.imageId) {
                        setFileList([
                            {
                                uid: '-1',
                                name: 'image.png',
                                status: 'done',
                                url: `data:image/png;base64,${data.resultData?.imageId}`,
                            },
                        ]);
                        setImage(form?.getFieldValue('logoId'));
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        };
        getImage();
    }, [form?.getFieldValue('logoId')]);

    const checkAcknowledegeButton = (_, value) => {
        if (selectDocLayout) {
            return Promise.resolve();
        }
        return Promise.reject(new Error(t('errorText.requiredField')));
    };

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            notification['error']({
                message: t('COOKIE.YouUploadFile'),
            });
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller'),
            });
        }

        return isJpgOrPng && isLt2M;
    };

    const onPreview = async (file) => {
        let src = file.url;

        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);

                reader.onload = () => resolve(reader.result);
            });
        }

        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    const uploadProps = {
        multiple: false,
        listType: 'picture-card',
        showUploadList: {
            showPreviewIcon: false,
        },
        beforeUpload,
        accept: '.png,.jpg,.jpeg',
        className: 'policy',
        fileList,
        onPreview,
        onChange(info) {
            const { status } = info.file;
            if (status === 'uploading') {
                info.file.status = 'done';
            }
            if (status === 'done' || status === 'removed') {
                setFileList(info.fileList);
            }
        },
        onSuccess(res, file) {
            form?.setFieldValue('logoId', res?.imageId);
            setImage(res?.imageId);
        },
        onError(err) {
            console.log('onError', err);
        },
        onRemove() {
            form?.setFieldValue('logoId', null);
            setImage();
        },
        customRequest: async ({ file, onSuccess, onError, onProgress }) => {
            let fileList = new FormData();
            fileList.append('image', file);
            fileList.append('fileName', file.name);
            fileList.append('action', 'image-create-application');
            // if (id) {
            //     fileList.append('action', 'image-create-application');
            //     // fileList.append('applicationId', editObject.applicationId);
            //     // fileList.append('applicationLogoId', editObject.applicationLogoId);
            // } else {
            //     fileList.append('action', 'image-create-application');
            // }

            try {
                const onUploadProgress = ({ total, loaded }) => {
                    onProgress(
                        {
                            percent: Math.round((loaded / total) * 100).toFixed(
                                2
                            ),
                        },
                        file
                    );
                };
                const { data } = await GlobalService.uploadImage(
                    fileList,
                    onUploadProgress
                );
                if (data?.resultData?.imageId) {
                    onSuccess(data?.resultData, file);
                } else {
                    onError('error');
                }
            } catch (error) {
                onError(error);
            }
        },
    };

    const uploadButton = (
        <div>
            <svg
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M15.8721 7.62647H13.1221V13.1265H7.62207V15.8765H13.1221V21.3765H15.8721V15.8765H21.3721V13.1265H15.8721V7.62647ZM14.4971 0.751465C6.90707 0.751465 0.74707 6.91147 0.74707 14.5015C0.74707 22.0915 6.90707 28.2515 14.4971 28.2515C22.0871 28.2515 28.2471 22.0915 28.2471 14.5015C28.2471 6.91147 22.0871 0.751465 14.4971 0.751465ZM14.4971 25.5015C8.43332 25.5015 3.49707 20.5652 3.49707 14.5015C3.49707 8.43772 8.43332 3.50147 14.4971 3.50147C20.5608 3.50147 25.4971 8.43772 25.4971 14.5015C25.4971 20.5652 20.5608 25.5015 14.4971 25.5015Z"
                    fill="#1890FF"
                />
            </svg>

            <div className="-mt-2 text-blue-500 opacity-90 pt-1">
                {t('Consent.AddLogo')}
            </div>
        </div>
    );

    const onNextStep = () => {
        form.validateFields([
            'titleTh',
            'templateNameTh',
            'showAcknowledgeButton',
            'effectiveDate',
        ])
            .then(() => {
                props.calProgress(100);
                props.nextStep();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <>
            <Sticky
                boundaryElement=".block_"
                stickyClassName="bg-white p-4 shadow rounded-lg z-50"
            >
                <div className="text-right">
                    <Button type="primary" size="large" onClick={onNextStep}>
                        {t('Consent.Next Step')} <ArrowRightOutlined />
                    </Button>
                </div>
            </Sticky>
            <Divider className="my-4" />
            <div className="flex item-center gap-x-3">
                <div>{LogoStep1}</div>
                <div>
                    <div className="font-medium text-base text-[#65707A]">
                        {t('MyTask.Step')} 1 / 2
                    </div>
                    <div className="font-semibold text-xl text-[#171717]">
                        {t('Consent.TermStep1')}
                    </div>
                </div>
            </div>
            <div>
                <Progress
                    strokeColor={{
                        '0%': '#C2BAFF',
                        '100%': '#7B67FB',
                    }}
                    percent={currentProgress}
                    status="active"
                    showInfo={false}
                />
            </div>
            <Form.Item
                label={
                    <div className="text-[#171717] text-sm font-semibold">
                        {t('Consent.TitleDocument')} (TH)
                    </div>
                }
                name="titleTh"
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <EditorPrivacy />
            </Form.Item>
            <Form.Item
                label={
                    <div className="text-[#171717] text-sm font-semibold">
                        {t('Consent.TitleDocument')} (EN)
                    </div>
                }
                name="titleEn"
            >
                <EditorPrivacy />
            </Form.Item>
            <Divider className="mt-0 mb-2" />
            <Form.Item
                label={
                    <div className="text-[#171717] text-sm font-semibold">
                        {t('Consent.TemplateName')} (TH)
                    </div>
                }
                name="templateNameTh"
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
            >
                <EditorPrivacy />
            </Form.Item>
            <Form.Item
                label={
                    <div className="text-[#171717] text-sm font-semibold">
                        {t('Consent.TemplateName')} (EN){' '}
                    </div>
                }
                name="templateNameEn"
            >
                <EditorPrivacy />
            </Form.Item>
            <Divider className="mt-0 mb-2" />
            <Form.Item
                className="mb-2"
                label={
                    <div className="text-[#171717] text-sm font-semibold">
                        {t('Consent.FieldLastUpdate')}
                    </div>
                }
                rules={[
                    {
                        required: true,
                        message: t('errorText.requiredField'),
                    },
                ]}
                name="effectiveDate"
            >
                <DatePicker
                    allowClear={false}
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="DD/MM/YYYY"
                    format="DD/MM/YYYY"
                />
            </Form.Item>
            <Form.Item
                name={'logoId'}
                label={
                    <span className="text-tiny font-semibold">{t('Logo')}</span>
                }
            >
                <ImgCrop
                    beforeCrop={beforeUpload}
                    showGrid
                    rotationSlider
                    aspectSlider
                    showReset
                >
                    <Upload {...uploadProps}>
                        {fileList.length < 1 && uploadButton}
                    </Upload>
                </ImgCrop>
            </Form.Item>
            <Divider className="mt-0 mb-2" />
            <Form.Item
                label={
                    <span className="text-tiny font-semibold">
                        {t('Consent.DocumentType')}
                        <div className="requiredCustom">*</div>
                    </span>
                }
                name="showAcknowledgeButton"
                rules={[
                    {
                        validator: checkAcknowledegeButton,
                    },
                ]}
            >
                <label className="radio-toolbar-template inline-block mr-2 mb-2">
                    <input
                        checked={selectDocLayout === 1}
                        type="checkbox"
                        onClick={() => {
                            setSelectDocLayout(1);
                            form.setFieldValue('showAcknowledgeButton', false);
                            form.setFields([
                                {
                                    name: 'showAcknowledgeButton',
                                    errors: [],
                                },
                            ]);
                        }}
                    />

                    <>
                        <div className="r-label-color-template p-0.5 rounded-md border-2  border-solid border-[#DBDBDB] text-center">
                            <div className="rounded-full border-2 cursor-pointer flex">
                                <div className="flex-col space-y-2 items-center px-5 py-3">
                                    <img
                                        className="object-cover"
                                        src={term_read_only}
                                        alt=""
                                    />
                                    <div className="font-semibold text-sm">
                                        {t('Consent.DocType1')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </label>
                <label className="radio-toolbar-template inline-block mr-2 mb-2">
                    <input
                        checked={selectDocLayout === 2}
                        type="checkbox"
                        onClick={() => {
                            setSelectDocLayout(2);
                            form.setFieldValue('showAcknowledgeButton', true);
                            form.setFields([
                                {
                                    name: 'showAcknowledgeButton',
                                    errors: [],
                                },
                            ]);
                        }}
                    />

                    <>
                        <div className="r-label-color-template p-0.5 rounded-md border-2 border-solid border-[#DBDBDB] text-center">
                            <div className="rounded-full border-2 cursor-pointer flex">
                                <div className="flex-col space-y-2 items-center px-5 py-3">
                                    <img
                                        className="object-cover"
                                        src={term_checked}
                                        alt=""
                                    />
                                    <div className="font-semibold text-sm">
                                        {t('Consent.DocType2')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </label>
            </Form.Item>
            <div className="flex items-center gap-2">
                <img alt="info1" src={circleInfo} />
                <div className="text-sm">{t('Consent.DocDesc1')}</div>
            </div>
            <div className="flex items-start gap-2">
                <img className="pt-1" alt="info2" src={circleInfo} />
                <div className="text-sm whitespace-pre-line">
                    {t('Consent.DocDesc2')}
                </div>
            </div>
        </>
    );
}

// {
//    "titleTh":"",
//    "titleEn":"",
//    "templateNameTh":"",
//    "templateNameEn":"",
//    "logo":"",
//    "showAcknowledgeButton":true,
//    "consentTxnGroupId":"",
//    "isPublish":false //true=save&publish, false=save
// }

const LogoStep1 = (
    <svg
        width="53"
        height="53"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="26.5"
            cy="26.5"
            r="25.5536"
            fill="white"
            stroke="#7B67FB"
            strokeWidth="1.89286"
        />
        <path
            d="M26.8214 5.67969C15.322 5.67969 6 15.0017 6 26.501C6 38.0004 15.322 47.3224 26.8214 47.3224C38.3207 47.3224 47.6427 38.0004 47.6427 26.501C47.6293 15.0073 38.3151 5.69307 26.8214 5.67969Z"
            fill="#7B67FB"
        />
        <path
            d="M29.9248 16.627V36.6247H25.6967V20.6402H25.5796L21 23.5109V19.7614L25.9506 16.627H29.9248Z"
            fill="white"
        />
    </svg>
);
